export const LOGIN_ATTEMPT_LIMIT = 3;

export const CARD_READER_MIN_VERSION = '1.4.1.0';
